const websocket = {

  subscribers: {},
  options: {},

  isEnabled() {
    if (process.env.VUE_APP_WEBSOCKET_URL) {
      return true
    }
    return false
  },

  unregistry(event, funToUnsub) {
    if (this.subscribers[event] == undefined) {
      return
    }

    this.subscribers[event].forEach((fun, key) => {
      if (fun == funToUnsub) {
        delete this.subscribers[event][key]
      }
    })
  },

  registry(event, fun) {
    if (this.subscribers[event] == undefined) {
      this.subscribers[event] = []
    }
    this.subscribers[event].push(fun)
  },

  send(msg) {
    this.connection.send(JSON.stringify(msg))
  },

  auth() {
    this.send({'type': 'auth', 'data': {'token': localStorage.getItem('access_token')}})
  },


  createConnection() {
    if (this.connection != null) {
      return
    }
    this.connection = new WebSocket(this.options.url)

    this.connection.onopen = () => {
      this.auth()
    }

    this.connection.onmessage = (e) => {
      let message = JSON.parse(e.data)

      if (this.subscribers[message.type] == undefined) {
        return
      }
      this.subscribers[message.type].forEach(fun => fun(message))
    };

    this.connection.onclose = ((e) => {
      if (e.code != 1000) {
        setTimeout(() => this.createConnection(), 3000)
      }
    })
  },

  disconnect() {
    this.connection.close()
  },

  install(app, options) {
    this.subscribers = {}
    app.prototype.$websocket = this
    this.options = options
  }
}
export default websocket